module.exports = __webpack_public_path__ + "img/scanImg.dc27d9b0.png";